import { useEffect, useState } from 'react';

/**
 * Stan połączenia sieciowego przeglądarki.
 *
 * `navigator.onLine` bywa optymistyczny (Wi-Fi bez internetu wciąż liczy się jako
 * "online"), ale wystarcza do jednego celu: pokazać komunikat zamiast wiszącego żądania,
 * gdy przeglądarka na pewno wie, że sieci nie ma — patrz `docs/05-ux-styl-szkicu.md` §5.6.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
